export class Loading {
	static show() {
		let overlay = document.getElementById("global-loading-overlay");
		if (!overlay) {
			overlay = document.createElement("div");
			overlay.id = "global-loading-overlay";
			overlay.style.cssText = `
                position: fixed; inset: 0; z-index: 9999;
                background: rgba(0, 0, 0, 0.4); display: flex; 
                justify-content: center; align-items: center;
                backdrop-filter: blur(2px);
            `;
			overlay.innerHTML = `<div class="loading-spinner"></div>`;
			document.body.appendChild(overlay);

			if (!document.getElementById("nine-util-style")) {
				const style = document.createElement("style");
				style.id = "nine-util-style";
				style.innerHTML = `
                    .loading-spinner {
                        width: 48px; height: 48px;
                        border: 5px solid rgba(255, 255, 255, 0.3);
                        border-top-color: white; border-radius: 50%;
                        animation: nine-spin 1s linear infinite;
                    }
                    @keyframes nine-spin { to { transform: rotate(360deg); } }
                `;
				document.head.appendChild(style);
			}
		}
		overlay.style.display = "flex";
	}

	static hide() {
		const overlay = document.getElementById("global-loading-overlay");
		if (overlay) overlay.style.display = "none";
	}
}